























































import Vue from 'vue'
import './Modal.scss'

export default Vue.extend({
  name: 'Modal',
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    beta: {
      type: Boolean,
      required: false,
      default: false
    },
    submitText: {
      type: String,
      required: false,
      default: 'Submit'
    },
    cancelText: {
      type: String,
      required: false,
      default: 'Cancel'
    },
    showCancel: {
      type: Boolean,
      required: false,
      default: true
    },
    showFinish: {
      type: Boolean,
      required: false,
      default: true
    },
    buttonActive: {
      type: Boolean,
      required: false,
      default: true
    },
    width: {
      type: String,
      required: false
    },
    customPopup: {
      type: Boolean,
      required: false,
      default: false
    },
    customClass: {
      type: String,
      required: false,
      default: ''
    }
  },
  created () {
    // @keyup.esc isn't reliable for triggering close
    // this works reliably
    document.onkeydown = evt => {
      const keyEvent = (evt ? evt : window.event) as KeyboardEvent|undefined
      if (keyEvent === undefined) return
      if (keyEvent.keyCode === 27) this.close()
    }
  },
  beforeDestroy () {
    document.onkeydown = null
  },
  methods: {
    close () {
      this.$emit('close')
    },
    submit () {
      if (this.buttonActive) {
        this.$emit('submitted')
      }
    }
  }
})
